import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { PHOTOS } from "@/pages/Gallery";

const SLIDES = PHOTOS.filter((p) => p.cat !== "Events & Flyers");
const INTERVAL = 6000;

export default function StorySlideshow() {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) { return; }
    const t = setInterval(() => setI((x) => (x + 1) % SLIDES.length), INTERVAL);
    return () => clearInterval(t);
  }, [paused]);

  const s = SLIDES[i];
  return (
    <section className="relative bg-[#03045E] overflow-hidden" data-testid="story-slideshow" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <div className="relative h-[70vh] min-h-[460px] max-h-[720px]">
        <AnimatePresence mode="sync">
          <motion.div key={s.src} className="absolute inset-0" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 1.6 }}>
            <img src={s.src} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover blur-2xl scale-110 opacity-50" />
            <motion.img src={s.src} alt={s.alt} data-testid="slideshow-image" className="relative mx-auto h-full w-auto max-w-full object-contain" initial={{ scale: 1 }} animate={{ scale: 1.06 }} transition={{ duration: INTERVAL / 1000 + 1.6, ease: "linear" }} />
          </motion.div>
        </AnimatePresence>
        <div className="absolute inset-0 bg-gradient-to-t from-[#03045E] via-[#03045E]/30 to-transparent pointer-events-none" />
        <div className="absolute bottom-0 inset-x-0 max-w-7xl mx-auto px-5 sm:px-8 pb-10 text-white">
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-sky-300">Rakim's Story</p>
          <h1 className="font-display uppercase font-bold text-4xl sm:text-5xl lg:text-6xl mt-2">Remembering Rakim</h1>
          <p className="font-script text-2xl md:text-3xl text-sky-100 mt-2">A little boy whose legacy is saving lives.</p>
          <div className="flex flex-wrap items-center gap-2 mt-5">
            {SLIDES.map((p, j) => (
              <button key={p.src} onClick={() => setI(j)} aria-label={`Show photo ${j + 1}`} data-testid={`slideshow-dot-${j}`} className={`h-2 rounded-full transition-all duration-300 ${j === i ? "w-8 bg-[#FF6B35]" : "w-2 bg-white/50 hover:bg-white"}`} />
            ))}
            <Link to="/gallery" className="ml-3 text-xs font-bold uppercase tracking-wider text-sky-200 hover:text-white" data-testid="slideshow-gallery-link">View gallery →</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
